import React, { Component } from "react";
import { connect } from "react-redux";

export class StudyGroupUserChat extends Component {
  render() {
    return <div>StudyGroupUserChat</div>;
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(StudyGroupUserChat);



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserChat.jsx